import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { BsClipboard, BsCheck2 } from 'react-icons/bs';
import { isMostlyPersian } from '../utils/langDetect';

function MessageBubble({ message, darkMode }) {
  const isUser = message.type === 'user';
  const [copied, setCopied] = useState(false);
  const isPersian = isMostlyPersian(message.text);

  const handleCopy = () => {
    navigator.clipboard.writeText(message.text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const textStyle = {
    direction: isPersian ? 'rtl' : 'ltr',
    textAlign: isPersian ? 'right' : 'left',
    fontFamily: isPersian ? 'Shabnam' : 'Ubuntu',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    backgroundColor: isUser
      ? (darkMode ? '#017e95' : '#d1ecf1')
      : (darkMode ? '#444' : '#e2e3e5'),
    color: darkMode ? '#fff' : '#000',
  };

  return (
    <div className={`d-flex mb-2 ${isUser ? 'justify-content-end' : 'justify-content-start'}`}>
      <div className="d-flex align-items-start gap-2" style={{ maxWidth: '80%' }}>
        {isUser && (
          <>
            <div className="p-2 rounded shadow-sm" style={textStyle}>
              {message.text}
            </div>
            <Button
              variant={darkMode ? 'secondary' : 'light'}
              size="sm"
              onClick={handleCopy}
              title="کپی"
              className="mt-1"
              style={{ minWidth: '32px', padding: '4px' }}
            >
              {copied ? <BsCheck2 /> : <BsClipboard />}
            </Button>
          </>
        )}
        {!isUser && (
          <>
            <Button
              variant={darkMode ? 'secondary' : 'light'}
              size="sm"
              onClick={handleCopy}
              title="کپی"
              className="mt-1"
              style={{ minWidth: '32px', padding: '4px' }}
            >
              {copied ? <BsCheck2 /> : <BsClipboard />}
            </Button>
            <div className="p-2 rounded shadow-sm" style={textStyle}>
              {message.text}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MessageBubble;
